import { YOO_FINDS_CDN } from "@/common";

const ROOT = `${YOO_FINDS_CDN}/h5/faqs`;

export const FAQS_TEACH_TRANSLATION = `${ROOT}/teach-translation.mp4`;
export const FAQS_TEACH_RATING = `${ROOT}/rating.png`;
export const FAQS_TEACH_RULES = `${ROOT}/rules.png`;
export const FAQS_TEACH_SAMPLE_LIST = `${ROOT}/sample-list.jpg`;
